/**
 * UnreadBadgeLabel — label-компонент для sidebar Refine, который показывает
 * красный бейдж с количеством непрочитанных incoming сообщений.
 *
 * Полл'инг каждые 5с. Также обновляет document.title — при unread > 0
 * добавляет "[N] " префикс, чтобы видно было в browser tab.
 */
import { useEffect, useState } from "react";
import { Badge, Space } from "antd";
import { API_URL } from "../dataProvider";

const POLL_MS = 5000;

const baseTitle = document.title;

export const UnreadBadgeLabel = ({ base }: { base: string }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const r = await fetch(`${API_URL}/admin/chat/unread-count`,
                              { credentials: "include" });
        if (alive && r.ok) {
          const d = await r.json();
          setCount(Number(d.count || 0));
        }
      } catch { /* network errors silently */ }
    };
    tick();
    const t = setInterval(tick, POLL_MS);
    return () => { alive = false; clearInterval(t); };
  }, []);

  useEffect(() => {
    if (count > 0) {
      document.title = `[${count}] ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
  }, [count]);

  return (
    <Space size={6}>
      {base}
      {count > 0 && (
        <Badge count={count} size="small"
               style={{ backgroundColor: "#ff4d4f" }} />
      )}
    </Space>
  );
};
